import axios from "axios";
import constants from "../constants";
import { EventBus } from './event-bus.js';

export default {

    uploadFiles(obj) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.post(constants.BASE_URL + "/imports-exports", obj, {
            withCredentials: true,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            return response.data;
        }).catch(error => {
            if(!error.includes("504")) {
                msgType = "updateError";
            }
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while uploading file"
                });
            }
        });
    }, 
    getImportExportStatus() {
        var msgType = "fetchSuccess";
        return axios.get(constants.BASE_URL + "/imports-exports/import-status", {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "fetchError";
            })
            .finally(() => {
                if (msgType == 'fetchError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching import status"
                    });
                }
            });
    },
    getImportExportData(input) {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/imports-exports?" + input, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching import/export response"
                    });
                }
            });
    },
    getFailureData(id) {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/imports-exports/failure-records/" + id, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching import/export failure data"
                    });
                }
            });
    },
    exportFiles(fileType,Id) {
        let queryStr = constants.BASE_URL + "/imports-exports/exports?filetype[]="+fileType;
        if (Id) {
            queryStr += "&ids=" + Id;
        }
        const link = document.createElement('a');
        link.href = queryStr;
        link.click();
    },
    validateExportFiles(formData) {
        axios.defaults.withCredentials = true;
        var msgType = "updateSuccess";
        return axios.post(constants.BASE_URL + "/imports-exports/validate", formData, {
            withCredentials: true,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            return response.data;
        }).catch(error => {
            msgType = "updateError";
        }).finally(() => {
            if (msgType == 'updateError') {
                EventBus.$emit('error-notification', {
                    "msg": "Error while validating file(s)"
                });
            }
        });
    }
}
